/** @type {Styles} */
export const styles = {
  rounded: {
    borderRadius: 4,
  },
  skeleton: {
    backgroundColor: 'gray.12',
  },
  defaultRectangular: {
    width: 140,
    height: 8,
  },
}
